<template>
  <div>
    <div
      class="chart"
      ref="chartdiv"
      :id="chart.key"
    />
  </div>
</template>
<script>
// eslint-disable-next-line
import createBarChart from "./charts/horizontal-barchart";
export default {
  name: 'HorizontalBarchart',
  props: {
    chart: {
      required: true,
      type: Object
    },
    xAxis: {
      required: false,
      type: Object,
      default: null,
      validator: function (value) {
        let seriesValid = true
        if (value.series) {
          value.series.forEach(series => {
            seriesValid = !!(series.xAxisKey && series.yAxisKey)
          })
        }
        return value.series && seriesValid
      }
    },
    yAxis: {
      required: false,
      type: Object,
      default: null,
      validator: function (value) {
        return value.key
      }
    }
  },
  computed: {
    measure () {
      return this.measureFilter || null
    }
  },
  data: function () {
    return {
      renderedChart: null,
      renderedChartTitle: null,
      subscription: null
    }
  },
  mounted () {
    if (
      this.getChartData(this.chart.key) &&
      this.renderedChart === null &&
      this.$refs.chartdiv
    ) {
      this.$nextTick(
        function () {
          let chartOutput = createBarChart(
            this.getChartData(this.chart.key),
            this.$refs.chartdiv,
            this.measureFilter,
            this.$attrs.titleString,
            this.xAxis,
            this.yAxis,
            this.measure
          )
          this.renderedChart = chartOutput[0]
          this.renderedChartTitle = chartOutput[1]
          this.renderedChart.events.on(
            'ready',
            function (event) {
              this.$parent.$emit('update:chartReady', true)
            }.bind(this)
          )
        }.bind(this)
      )
    }
    this.subscription = this.$store.subscribe(mutation => {
      switch (mutation.type) {
        case this.getChartDataMutationString(this.chart.key):
          if (this.renderedChart) {
            if (this.measureFilter === 'percent') {
              this.renderedChart.xAxes.values[0].max = 100
            } else {
              this.renderedChart.xAxes.values[0].max = null
            }
            let data = this.getChartData(this.chart.key)
            if (typeof data !== 'string' && data) {
              data.forEach(function (datum) {
                if (datum.valueSuppressed) {
                  datum.value = 0
                }
              })
            }

            this.renderedChart.data = data
            this.renderedChartTitle.text =
              '[font-size: 1.75rem font-weight: 500 line-height:1.2]' +
              this.$attrs.titleString +
              '[/]'
          }
          break
      }
    })
  },
  beforeDestroy () {
    if (this.renderedChart) {
      this.renderedChart.dispose()
      this.renderedChart = null
    }
    this.subscription()
  }
}
</script>
